<template>
    <div class="video-view">
        <template v-if="dummy">
            <video :src="videoSrc" :width="width" :height="height" autoplay repeat />
        </template>
        <template v-else>
            <video :src="videoSrc" :width="width" :height="height" controls />
        </template>
    </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import DummyVideo from "@/assets/videos/dummy_video.mp4";

const FilesApi = ApiFactory.get("files");

export default {
    name: "VideoView",
    props: {
        src: {
            type: [String, Number],
            default: null
        },
        width: {
            type: [String, Number],
            default: "100%"
        },
        height: {
            type: [String, Number],
            default: "auto"
        }
    },
    data() {
        return {
            video: null,
            dummy: false
        };
    },
    computed: {
        videoSrc() {
            if (this.video) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dummy = false;
                return this.video;
            } else {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dummy = true;
                return DummyVideo;
            }
        }
    },
    watch: {
        src: {
            handler(value) {
                this.downloadVideo(value);
            },
            immediate: true
        },
        videoSrc: {
            handler(value) {
                if (value === DummyVideo) {
                    this.dummy = true;
                } else {
                    this.dummy = false;
                }
            },
            immediate: true
        }
    },
    methods: {
        async downloadVideo(id) {
            if (id) {
                const response = await FilesApi.getFile(id);
                if (response.ok) {
                    this.video = URL.createObjectURL(response.blob);
                }
            }
        }
    }
};
</script>
